import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { CloseIcon } from '../../icons/close';

import styles from './menu.module.css';
import { useCallback } from 'react';

interface MenuItemProps extends React.ComponentProps<'div'> {
  label?: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClose?: () => void;
}

export const MenuHeader: React.FC<MenuItemProps> = ({ label, onClick, onClose, leftIcon, rightIcon, ...props }) => {
  const { t } = useTranslation();

  const handleClose: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      if (onClose) {
        e.stopPropagation();
        onClose();
      }
    },
    [onClose]
  );

  return (
    <div {...props} className={classNames(styles.menuItem, props.className)} onClick={onClick}>
      {leftIcon && <div className={classNames(styles.icon, styles.leftIcon)}>{leftIcon}</div>}

      <div className={styles.menuItemLabel}>
        <span className={styles.menuItemLabelText}>{label}</span>
      </div>

      {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}

      <button
        className={styles.close}
        onClick={handleClose}
        data-testid="close-button"
        aria-label={t('ui.menu.close.label')}
      >
        <CloseIcon />
      </button>
    </div>
  );
};
